import { Injectable, effect, inject, signal } from '@angular/core';
import { deleteToken, MessagePayload } from 'firebase/messaging';
import { AuthService } from './auth.service';
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { ErrorService } from './error.service';
import { Storage } from '@ionic/storage-angular';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';

const firebaseConfig = {
  apiKey: "AIzaSyDf5-R6lCNSxfqt-jN1m89RxjKePHsCmn4",
  authDomain: "planski-415f5.firebaseapp.com",
  projectId: "planski-415f5",
  storageBucket: "planski-415f5.firebasestorage.app",
  messagingSenderId: "221772524797",
  appId: "1:221772524797:web:978963bc801343b9912294",
  measurementId: "G-YFEBCFMF16"
};

const VAPID_KEY = "BA0gt2Ro5UjTDF_agTgzZehTq1J8zfq5WSEz77QyxiJ3zheLIcxpqWel4b3azfZ5KFyPcXzunZ645bnjMz91hkc";

@Injectable({ providedIn: 'root' })
export class PushNotificationsService {
  private authService = inject(AuthService);
  private errorService = inject(ErrorService);
  private storage = inject(Storage);
  private http = inject(HttpClient);
  
  /**
   * Queue and tick for handling of push notifications
   */
  private _queue: MessagePayload[] = [];
  readonly notificationTick = signal(0);

  /**
   * Readonly signal getter for privilege alert shown state
   */
  private _privilegeAlertShown = signal<boolean>(false);
  privilegeAlertShown = this._privilegeAlertShown.asReadonly();

  private app = initializeApp(firebaseConfig);
  private messaging = getMessaging(this.app);

  private serviceWorkerRegistration: ServiceWorkerRegistration | null = null;
  private _unsubscribeOnMessage: (() => void) | null = null;

  constructor() {
    effect(() => {
      if (this.authService.isInitialized() && !this.authService.isLoggedIn()) {
       // this._unregisterServiceWorker();
        this._deleteFcmToken();
        this._unsubscribeOnMessage?.();
        this._unsubscribeOnMessage = null;
        this._unsetPrivilegeAlertShown();
      }
    });
  }
  async init() {
    const privilegeAlertShown = await this.storage.get('notifications-privilege-alert-shown');
    this._privilegeAlertShown.set(privilegeAlertShown !== null ? privilegeAlertShown : false);
  }


  async initPushNotifications() {
    //await this._registerServiceWorker();
    this._unsubscribeOnMessage = onMessage(this.messaging, (payload: MessagePayload) => {
      this.enqueue(payload);
    });
  }

  /** queue push notification */
  enqueue(notification: MessagePayload) {
    this._queue.push(notification);
    this.notificationTick.update(v => v + 1);
  }

  /** dequeue push notification */
  dequeue(): MessagePayload | null {
    return this._queue.shift() ?? null;
  }


  /** request push notification permission */
  async requestNotificationPermission(): Promise<string | null> {
    try {
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        this.errorService.report({ message: 'Privilegije za primanje push obavijesti odbijene. Ukoliko želite koristiti ovu functionalost, provjerite dozvole u postavkama mobilnog uređaja' });
        return null;
      }
     // await this._registerServiceWorker();
      const token = await getToken(this.messaging, 
        { vapidKey: VAPID_KEY,
     //     serviceWorkerRegistration: this.serviceWorkerRegistration
        });

      if (!this._unsubscribeOnMessage) {
        this.initPushNotifications();
      }

      if (!this.privilegeAlertShown()) {
         this.storage.set('notifications-privilege-alert-shown', true);
         this._privilegeAlertShown.set(true);
      }
      if (token) {
        await this._persistToken(token);
      }
      
    } catch (error) {
      this.errorService.report({ message: 'Greška pri dohvaćanju tokena za push obavijesti' });
    }
  }

  async _persistToken(newToken: string) {
    const oldToken = await this.storage.get('planski_fcm_token');

    if (oldToken != newToken) {
      try {
        const persisted = await firstValueFrom(this.http.post<any>('/api/rpc/r_upsert_token', { p_old_token: oldToken, p_new_token: newToken }));
        if (persisted) {
          await this.storage.set('planski_fcm_token', newToken);
        }
      } catch (error) {
        this.errorService.report({ message: 'Greška pri spremanju postavki za push notifikacije' });
      }
    }
  }

  private async _registerServiceWorker() {
    if (!('serviceWorker' in navigator)) return;
  
    const existing = await navigator.serviceWorker.getRegistration('/firebase-messaging-sw.js');
    this.serviceWorkerRegistration = existing ?? await navigator.serviceWorker.register(
      '/firebase-messaging-sw.js', 
      { scope: '/' }
    );
  
    // Wait for this worker to be active
    if (this.serviceWorkerRegistration.installing) {
      await new Promise<void>(resolve => {
        this.serviceWorkerRegistration!.installing!.addEventListener('statechange', (e) => {
          if ((e.target as ServiceWorker).state === 'activated') {
            resolve();
          }
        });
      });
    }
  }

  private async _unregisterServiceWorker() {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      if (registration.active?.scriptURL.includes('firebase-messaging-sw.js')) {
        await registration.unregister();
      }
    }
  }

  private async _deleteFcmToken() {
    try {
      await deleteToken(this.messaging);
    } catch (e) { /* token may already be gone */ }
  }

  private async _unsetPrivilegeAlertShown() {
    await this.storage.set('notifications-privilege-alert-shown', false);
    this._privilegeAlertShown.set(false);
  }

}